import React from 'react';
import PermissionGate from 'global/components/permission-gate';
import withRouter from 'react-router-dom/withRouter';
import AssessmentTemplates from './assessmenttemplates';
import EditionList from './editions';
import Panels from '../../../global/components/panels';

export default PermissionGate(
  withRouter((props) => {
    const panels = [
      { id: 'editions', title: 'Editions', component: (p) => <EditionList {...p} /> },
      // { id: 'scorecards', title: 'Scorecards', component: p => <AssessmentTemplates {...p} /> },
      { id: 'templates', title: 'Assessment Templates', component: (p) => <AssessmentTemplates {...p} /> },
    ]

    return <Panels panels={panels} />;
  })
);
